// extracted by mini-css-extract-plugin
module.exports = {"input":"DirectFlightSwitch-module__input___f7CJV"};